import config from 'react-global-configuration';

config.set({
    cpBooking: 'cp-booking',
    pageNumber: 'pageNumber',
    pageSize: 'pageSize',
    customer: 'customer',
    product: 'product',
    subProduct: 'sub-product',
    temperature: 'temperature',
    shipper: 'shipper',
    consignee: 'consignee',
    productId: 'productId',
    subProductId: 'subProductId',
    currency: 'currency',
    exceptionReason: 'exception-reason',
    v1: 'v1',
    employee: 'employee',
    vehicle: 'vehicle',
    city: 'city',
    event: 'event',
    tripRoute: 'trip-route',
    api: 'api',
    country: 'country',
    countryId: 'country-id',
    odaCity: 'oda-city',
    cityId: 'city-id',
    clientSubId: 'client-sub-id',
    cancel: 'cancel',
    industryType: 'industry-type',
    salesPerson: 'sales-person',
    customerAddress: 'customer-address',
    customerSubAccount: 'customer-sub-account',
    customerBillingDetail: 'customer-billing-detail',
    tripPlan: 'tripplan',
    tripType: 'trip-type',
    tripLoadType: 'trip-load-type',
    employeeId: 'employeeId',
    index: 'index',
    count: 'count',
    operation: 'operation',
    position: 'position',
    code: 'code',
    assign: 'assign',
    deliverysheet: 'delivery-sheet',
    pallet: 'pallet',
    trackingHistory: 'tracking-history',
    bookingOperationDetail: 'booking-operation-detail',
    assignDelivery: 'assign-delivery',
    userName: 'user-name',
    rto: 'rto',
    wayBill: 'waybill',
    region: 'region',
    pickup: 'pickup',
    getPieceBarCodes: 'get-piece-bar-codes',
    scanAtHub: 'scan-at-hub',
    getVolumeMetricWeight: 'get-volume-metric-weight',
    waybillSticker: 'waybill-sticker',
    manualWayBill: 'manual-waybill',
    print: 'print',
    customerAccountFile: 'customer-account-file',
    uploadFile: 'upload-file',
    palletCode: 'pallet-code',
    subCLientIdQuery: 'subClientId',
    subClientQuery: 'sub-client-id',
    clientQuery: 'client',
    palletSticker: 'pallet-sticker',
    customerView: 'customer-view',
    filter: 'filter',
    customerListViewUser: 'customer-list-view-user',
    fileType: 'file-type',
    fileTypeId: 'file-type-id',
    download: 'download',
    user: 'user',
    tree: 'tree',
    countByEvent: 'count-by-event',
    podFileOptions: 'pod-file-options',
    pod: 'pod',
    countryCity: 'country-city',
    tracking: 'tracking',
    podFiles: 'pod-files',
    accountInfo: 'account-info',
    booking: 'booking',
    boxSeal: 'box-seal',
    fileAttachment: 'file-attachment',
    upload: 'upload',
    downloadAll: 'download-all',
    downloadFile: 'download-file',
    updateTrayPieceBarcode: 'update-tray-piece-barcode',
    temperatureDevice: 'temperature-device',
    temperatureWayBill: 'waybillno',
    customerBooking: 'customer-booking',
    excelBulkBooking: 'excel-bulk-booking',
    customerReport: 'customer-report',
    cityConsignee: 'city-consignee',
    cityShipper: 'city-shipper',
    master: 'master',
    all: 'all',
    trayBarcode: 'tray-barcode',
    trayPieceBarcode: 'tray-piece-barcode',
    getTrayPieceBarcode: 'get-tray-piece-barcode',
    consigneeConfirmLs: 'consignee-confirm-ls',
    subClient: 'sub-client',
    newManualWaybill: 'new-manual-waybill',
    newManualSticker: 'new-waybill-sticker',
    createNewShipper: 'create-new-shipper',
    createNewConsignee: 'create-new-consignee',
    productDescription: 'product-description',
    occ: 'occ',
    clientId: 'client-id',

});

export default config